import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeLine: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-line"><path d="M3.75 9L12 2.25L20.25 9V20.25H3.75V9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 16.25H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHomeLine;
